import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { FirebaseFunctionsService } from '../../../services/firebase.functions.service';
import { OrderDetails } from '../../../constants';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { Message } from 'primeng/message';
import { AccordionModule } from 'primeng/accordion';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-order-history',
    imports: [
        CommonModule,
        ButtonModule,
        CardModule,
        Message,
        AccordionModule,
        ProgressSpinnerModule
    ],
    providers: [MessageService],
    templateUrl: './order-history.component.html',
    styleUrl: './order-history.component.scss'
})
export class OrderHistoryComponent {
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  firebaseFunctionsService = inject(FirebaseFunctionsService);
  messageService = inject(MessageService);
  dynamicDialogRef = inject(DynamicDialogRef);
  dialogService = inject(DialogService);

  orders?: OrderDetails[];

  orderDetails?: OrderDetails;
  selectedOrder?: OrderDetails;

  constructor() {
    this.firebaseFirestoreService.lastRetrievedOrder = undefined;
    this.getOrders();
  }

  async getOrders() {
    const data = await this.firebaseFirestoreService.getOrders();
    if(data) {
      this.orders = [...(this.orders as OrderDetails[] || []),...data];
    } else {
      this.orders = [...(this.orders as OrderDetails[] || [])]
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsCost(storeReceipts: any[]) {
    return storeReceipts?.reduce((pre,cur) => pre.total + cur.total, 0) || 0;
  };

  viewOrderDetails(order: OrderDetails) {
    this.dialogService.open(OrderDetailsComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: {order, userRole: 'customer'}
    });
  }

  addItemToCart() {
    this.dynamicDialogRef.close('addItem');
  }

  getDisplayDate(date: string) {
    return new Date(date).toDateString();
  }
}
